import React, { useState } from "react";
import logo from "../images/logo.png";
// import { useForm } from "./FormContext";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // const { openForm } = useForm();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav>
      <div className="container">
        <div className="nav_inner">
          <a href="#" className="logo">
            <img src={logo} alt="logo" />
          </a>

          {/* mobile toggle button */}
          <div
            className="nav_toggle"
            id="navToggle"
            aria-label="Toggle navigation"
            onClick={toggleMenu}
          >
            ☰
          </div>

          <div
            className={`nav_links ${isMenuOpen ? "active" : ""}`}
            id="navMenu"
          >
            {/* close button inside mobile menu */}
            <div
              className="nav_close"
              id="navClose"
              aria-label="Close navigation"
              onClick={closeMenu}
            >
              ×
            </div>

            <ul className="nav_links_inner">
              <li>
                <a href="#about" onClick={closeMenu}>
                  About
                </a>
              </li>
              <li>
                <a href="#services" onClick={closeMenu}>
                  Services
                </a>
              </li>
              <li>
                <a href="#faq" onClick={closeMenu}>
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact" onClick={closeMenu}>
                  Contact
                </a>
              </li>
            </ul>
            {/* <button className="btn-new nav-btn" type="button" onClick={openForm}>Book a Free Call</button> */}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
